<template>
    <div class="grid-footer" v-show="showBody" v-if="page">
        <div class="grid-page-toolbar">
            <div
                title="上一页"
                class="button last-page"
                :class="{disabled:pageNum===1}"
                @click="toPage(pageNum-1)"
            >
                <lastPageImg v-bind="{color: '#999',width:'14px',height:'14px'}" />
            </div>
            <input class="page-num-input" :value="pageNum" @change="toPage($event.target.value)" />
            <span class="total-pages">&nbsp;/&nbsp;{{totalPage}}&nbsp;</span>
            <div
                title="下一页"
                class="button next-page"
                :class="{disabled:pageNum===totalPage}"
                @click="toPage(pageNum+1)"
            >
                <nextPageImg v-bind="{color: '#999',width:'14px',height:'14px'}" />
            </div>
            <selectField :options="{items:pageList,value:pageSize}" @change="pageSizeChangeHandle"></selectField>
            <span class="total-record">共&nbsp;{{totalRecord}}&nbsp;条</span>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        showBody: Boolean
    },

    computed: {
        ...mapState(["pageNum", "totalRecord", "page", "pageList", "pageSize"]),
        totalPage() {
            return this.$store.getters.totalPage;
        }
    },

    methods: {
        toPage(num) {
            this.$store.commit("updatePageNum", num);
        },

        pageSizeChangeHandle(_field, value) {
            this.$store.commit("updatePageSize", value);
        }
    }
};
</script>

<style scoped>
.grid-footer {
    height: 36px;
    display: flex;
    align-items: center;
    position: relative;
    border: 1px solid #eee;
    border-top: none;
    padding-bottom: 2px;
}

.grid-footer > .grid-page-toolbar {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.65);
    font-size: 12px;
}

.grid-footer > .grid-page-toolbar > .button {
    border: none;
    background-color: #fff;
    background-repeat: no-repeat;
    background-position: center;
}

.grid-footer > .grid-page-toolbar > .page-num-input {
    width: 42px;
    height: 24px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    text-align: center;
    color: #666;
    margin-right: 12px;
    margin-left: 13px;
    font-size: 12px;
}

.grid-footer > .grid-page-toolbar > .page-num-input:focus {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.grid-footer > .grid-page-toolbar > .total-record {
    color: rgba(0, 0, 0, 0.45);
    margin-left: 16px;
}

.grid-footer > .grid-page-toolbar > .select {
    width: 100px;
    height: 24px;
    padding: 0;
    margin-left: 21px;
    margin-left: 12px;
}

.grid-footer > .grid-page-toolbar > .total-pages {
    margin-right: 10px;
}

.grid-footer > .grid-page-toolbar > .button.disabled {
    opacity: 0.3;
    pointer-events: none;
}

.grid-footer > .grid-page-toolbar > .button.last-page,
.grid-footer > .grid-page-toolbar > .button.next-page {
    width: 20px;
    height: 24px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.grid-footer > .grid-footer-toolbar {
    position: absolute;
    right: 28px;
    display: flex;
    align-items: center;
}

.grid-footer > .grid-footer-toolbar > .item {
    width: 20px;
    height: 20px;
    background-position: center;
    background-repeat: no-repeat;
    margin-left: 8px;
    cursor: pointer;
}
</style>